/* @ngInject */
function NgsTicketsApiService($http) {
  this.cancelTicket = (productId, payload) => $http({
    method: 'POST',
    url: `${process.env.NGS_TICKETS_API}/cancel`,
    data: payload,
    headers: {
      'X-Nsft-Ngs-Product': productId
    }
  });

  this.payoutTicket = (productId, payload) => $http({
    method: 'POST',
    url: `${process.env.NGS_TICKETS_API}/payout`,
    data: payload,
    headers: {
      'X-Nsft-Ngs-Product': productId
    }
  });
}

export default NgsTicketsApiService;
